<template>
    <div class="container master-detail">
        <div class="row">
            <search-area class="col-12"></search-area>
        </div>
        <div class="row search-loading__parent">
            <transition name="fade-slide" mode="out-in">
                <search-categories v-if="!detail" class="col-12"></search-categories>
                <div v-if="detail" >
                    <div class="col-12">
                        <div class="back-wrapper">
                            <button class="button button--secondary back-button button--icon icon--before icon--arrow-left" @click="back" aria-label='back'>
                            </button>
                            <span><strong>{{ localization.categories.all }}</strong>&nbsp;({{totalResults}})</span>
                        </div>
                    </div>
                    <search-results class="col-12"></search-results>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import SearchArea from "../components/search-area/search-area.vue";
    import SearchCategories from "../components/search-categories/search-categories.vue";
    import SearchResults from "../components/search-results/search-results.vue";

    export default {
        name: "master-detail",
        computed: {
            detail() {
                return this.$store.getters.showDetail
            },
            localization() {
                return this.$store.getters.localize
            },
            totalResults() {
                const results = this.$store.getters.searchResults;
                const sectionKeys = Object.keys(results);
                let totalResults = 0;
                sectionKeys.forEach(key => {
                    totalResults += results[key].resultCount;
                });
                return totalResults
            }
        },
        methods: {
            back() {
                this.$store.dispatch('showDetailView', false)
            }
        },
        components: {SearchCategories, SearchArea, SearchResults}
    }
</script>
